/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Sorts_CompletionInputs */

const id_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyelesaian`)
};

const ms_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyiapan`)
};

const da_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuldførelse`)
};

const de_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschluss`)
};

const en_us2_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completion`)
};

const es_es2_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completado`)
};

const es_mx2_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalización`)
};

const fil_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagkumpleto`)
};

const fr_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complétion`)
};

const it_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamento`)
};

const hu_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítés`)
};

const nl_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltooiing`)
};

const no_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullføring`)
};

const pl_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukończenie`)
};

const pt_br2_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclusão`)
};

const pt_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclusão`)
};

const ro_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizare`)
};

const fi_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmiusaste`)
};

const sv_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slutförande`)
};

const vi_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn thành`)
};

const tr_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamamlanma`)
};

const cs_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončení`)
};

const bg_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завършване`)
};

const ru_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прохождение`)
};

const uk_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершення`)
};

const ar_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإكمال`)
};

const hi_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्णता`)
};

const th_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสมบูรณ์`)
};

const ja_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`達成率`)
};

const zh_cn2_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成度`)
};

const zh_hant1_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成度`)
};

const ko_profile_library_sorts_completion = /** @type {(inputs: Profile_Library_Sorts_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완료율`)
};

/**
* | output |
* | --- |
* | "Completion" |
*
* @param {Profile_Library_Sorts_CompletionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_sorts_completion = /** @type {((inputs?: Profile_Library_Sorts_CompletionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Sorts_CompletionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_sorts_completion(inputs)
	if (locale === "ms") return ms_profile_library_sorts_completion(inputs)
	if (locale === "da") return da_profile_library_sorts_completion(inputs)
	if (locale === "de") return de_profile_library_sorts_completion(inputs)
	if (locale === "en-US") return en_us2_profile_library_sorts_completion(inputs)
	if (locale === "es-ES") return es_es2_profile_library_sorts_completion(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_sorts_completion(inputs)
	if (locale === "fil") return fil_profile_library_sorts_completion(inputs)
	if (locale === "fr") return fr_profile_library_sorts_completion(inputs)
	if (locale === "it") return it_profile_library_sorts_completion(inputs)
	if (locale === "hu") return hu_profile_library_sorts_completion(inputs)
	if (locale === "nl") return nl_profile_library_sorts_completion(inputs)
	if (locale === "no") return no_profile_library_sorts_completion(inputs)
	if (locale === "pl") return pl_profile_library_sorts_completion(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_sorts_completion(inputs)
	if (locale === "pt") return pt_profile_library_sorts_completion(inputs)
	if (locale === "ro") return ro_profile_library_sorts_completion(inputs)
	if (locale === "fi") return fi_profile_library_sorts_completion(inputs)
	if (locale === "sv") return sv_profile_library_sorts_completion(inputs)
	if (locale === "vi") return vi_profile_library_sorts_completion(inputs)
	if (locale === "tr") return tr_profile_library_sorts_completion(inputs)
	if (locale === "cs") return cs_profile_library_sorts_completion(inputs)
	if (locale === "bg") return bg_profile_library_sorts_completion(inputs)
	if (locale === "ru") return ru_profile_library_sorts_completion(inputs)
	if (locale === "uk") return uk_profile_library_sorts_completion(inputs)
	if (locale === "ar") return ar_profile_library_sorts_completion(inputs)
	if (locale === "hi") return hi_profile_library_sorts_completion(inputs)
	if (locale === "th") return th_profile_library_sorts_completion(inputs)
	if (locale === "ja") return ja_profile_library_sorts_completion(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_sorts_completion(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_sorts_completion(inputs)
	return ko_profile_library_sorts_completion(inputs)
});
export { profile_library_sorts_completion as "profile.library.sorts.completion" }